import React, { useContext } from "react";

// auth
import { useAuth } from "frontend/hooks/useAuth";

// AssetDownloadContext
import AssetDownloadContext from "core/AssetDownload/Context";

// components
import TooltipWithMessage from "core/TooltipWithMessage";

const License = () => {
    const { isLoggedIn } = useAuth();
    const { state } = useContext(AssetDownloadContext);

    const {
        purchaseType: {
            key,
            licenseMessages: { auth, unauth }
        },
        isReadyForDownload,
        assetDownloadConfig
    } = state;

    const { purchaseTypeKeys } = assetDownloadConfig;

    let message = isLoggedIn ? auth : unauth;

    // When user first logs in, if its a Creative Commons image
    // We show `Creative Commons Photo` until they have chosen
    // a purchaseType and it is readyToDownload
    if (!isReadyForDownload && key !== purchaseTypeKeys.public) {
        message = { text: `Creative Commons Photo`, toolTipText: `` };
    }

    const { text, toolTipText, addLicenseText } = message;

    const licenseText = addLicenseText ? `${text} License` : text;

    return <TooltipWithMessage text={licenseText} toolTipText={toolTipText} />;
};

export default License;
